import { render } from "./ImportMapItem.vue?vue&type=template&id=42e16ff3&scoped=true"
import script from "./ImportMapItem.vue?vue&type=script&lang=js"
export * from "./ImportMapItem.vue?vue&type=script&lang=js"

import "./ImportMapItem.vue?vue&type=style&index=0&id=42e16ff3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e16ff3"]])

export default __exports__